import React from 'react';
import { useLicense } from '../context/LicenseContext';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Shield, Clock, CheckCircle2, AlertTriangle, RefreshCw, Loader2 } from 'lucide-react';

const SyncLicenseCard = ({ className = '' }) => {
  const { licenseStatus, isActivated, isExpired, isTampered, isWarning, licenseRemaining, syncLicense, syncing, refreshLicense } = useLicense();
  const { token } = useAuth();

  const handleSync = async () => {
    if (token) {
      const result = await syncLicense(token);
      if (result.success) {
        // toast is handled by context refresh
      }
    }
  };

  let statusColor = 'emerald';
  let StatusIcon = CheckCircle2;
  let statusLabel = 'Active';

  if (isTampered) {
    statusColor = 'rose'; StatusIcon = AlertTriangle; statusLabel = 'Tampered';
  } else if (isExpired) {
    statusColor = 'rose'; StatusIcon = AlertTriangle; statusLabel = 'Expired';
  } else if (isWarning) {
    statusColor = 'amber'; StatusIcon = Clock; statusLabel = 'Expiring Soon';
  } else if (!isActivated) {
    statusColor = 'slate'; StatusIcon = Shield; statusLabel = 'Not Activated';
  }

  return (
    <Card className={className} data-testid="sync-license-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Shield className={`h-5 w-5 text-${statusColor}-500`} />
          License
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <StatusIcon className={`h-4 w-4 text-${statusColor}-500`} />
            <span className={`text-sm font-semibold text-${statusColor}-600 dark:text-${statusColor}-400`}>
              {statusLabel}
            </span>
          </div>
          {isActivated && !isExpired && (
            <span className="text-sm text-slate-500" data-testid="license-days-badge">
              {licenseRemaining} days
            </span>
          )}
        </div>

        {isActivated && !isExpired && licenseRemaining <= 30 && (
          <div className="w-full bg-slate-200 dark:bg-slate-700 rounded-full h-2">
            <div
              className={`h-2 rounded-full ${licenseRemaining <= 7 ? 'bg-rose-500' : licenseRemaining <= 14 ? 'bg-amber-500' : 'bg-emerald-500'}`}
              style={{ width: `${Math.min(100, (licenseRemaining / 30) * 100)}%` }}
            />
          </div>
        )}

        <Button
          variant="outline"
          size="sm"
          className="w-full"
          onClick={handleSync}
          disabled={syncing}
        >
          {syncing ? (
            <><Loader2 className="h-3 w-3 mr-2 animate-spin" /> Syncing...</>
          ) : (
            <><RefreshCw className="h-3 w-3 mr-2" /> Re-validate</>
          )}
        </Button>
      </CardContent>
    </Card>
  );
};

export default SyncLicenseCard;
